module.exports = __webpack_public_path__ + "img/图片公式2.51059591.png";